import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  Paper,
  Link,
} from "@mui/material";
import { motion } from "framer-motion";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import backgroundImg from "../images/801A0256.jpg";

const ContactSection = () => {
  return (
    <Box>
      <Box
        component={motion.div}
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        sx={{
          py: { xs: 6, md: 10 },
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${backgroundImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          "&:before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 1,
          },
        }}
      >
        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
          {/* Header */}
          <Box sx={{ textAlign: "center", py: { xs: 15, md: 20 } }}>
            <Typography
              variant="h2"
              component="h1"
              sx={{
                fontWeight: 900,
                color: "white",
                mb: 3,
                fontSize: { xs: "2.2rem", sm: "3rem", md: "3.5rem" },
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                textShadow: "0 2px 10px rgba(0,0,0,0.3)",
              }}
            >
              CONTACT US
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "white",
                maxWidth: 800,
                mx: "auto",
                fontSize: { xs: "1.1rem", sm: "1.3rem", md: "1.5rem" },
                fontWeight: 500,
                lineHeight: 1.6,
                textShadow: "0 1px 5px rgba(0,0,0,0.5)",
              }}
            >
              For inquiries about our medical services, volunteer opportunities,
              or donations, please contact the Gundeti Foundation.
            </Typography>
          </Box>

          {/* Contact Info Boxes */}
        </Container>
      </Box>
      <Container maxWidth="lg">
        {" "}
        {/* Added Container for better alignment */}
        <Box sx={{ mt: 6, mb: 4 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  p: 3,
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  borderRadius: 4,
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: "50%",
                    backgroundColor: "#1976d2" /* Changed from green to blue */,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  <PhoneIcon sx={{ color: "white", fontSize: 30 }} />
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    mb: 1,
                    color: "#1976d2",
                  }} /* Changed from green to blue */
                >
                  CALL US
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  For more information and enquiries, call us at
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 700 }}>
                  +1 (123) 456-7890
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  p: 3,
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  borderRadius: 4,
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: "50%",
                    backgroundColor: "#1976d2" /* Changed from green to blue */,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  <LocationOnIcon sx={{ color: "white", fontSize: 30 }} />
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    mb: 1,
                    color: "#1976d2",
                  }} /* Changed from green to blue */
                >
                  OFFICE ADDRESS
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  For site visit and enquiries, visit us at
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 700 }}>
                  4648 Rocky Road Philadelphia PA, 1920
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  p: 3,
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  borderRadius: 4,
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: "50%",
                    backgroundColor: "#1976d2" /* Changed from green to blue */,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  <EmailIcon sx={{ color: "white", fontSize: 30 }} />
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    mb: 1,
                    color: "#1976d2",
                  }} /* Changed from green to blue */
                >
                  DROP AN EMAIL
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  For enquiries, drop us an email at
                </Typography>
                <Link
                  href="mailto:lalitagundeti@gmail.com"
                  sx={{
                    fontWeight: 700,
                    color: "#1976d2" /* Changed from green to blue */,
                    textDecoration: "none",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  lalitagundeti@gmail.com
                </Link>
              </Box>
            </Grid>
          </Grid>
        </Box>
        {/* Important Note */}
        <Box
          sx={{
            mt: 8,
            p: 3,
            borderRadius: 4,
            background: "rgba(255, 255, 255, 0.9)",
            border: "1px solid #1976d2" /* Changed border color to blue */,
            textAlign: "center",

            boxShadow:
              "0 4px 8px rgba(25, 118, 210, 0.1)" /* Added subtle blue shadow */,
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontWeight: 600,
              color: "#1976d2",
            }} /* Changed text color to blue */
          >
            We kindly request one day advance notice for appointments to ensure
            we can provide you with the best service.
          </Typography>
        </Box>
        {/* Map Section */}
        <Box
          sx={{
            mt: 5,
            mb: 5,
            height: "400px",
            borderRadius: 4,
            overflow: "hidden",
            border: "1px solid #1976d2" /* Added blue border */,
            boxShadow:
              "0 4px 12px rgba(25, 118, 210, 0.15)" /* Added blue shadow */,
          }}
        >
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11694.089686200983!2d75.9020053314632!3d17.66648785522194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc5d082b54ac5d5%3A0x3c719de6c83710d0!2sSolapur%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1757427792905!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Gundeti Foundation Location"
          ></iframe>
        </Box>
      </Container>{" "}
      {/* Closing the Container tag */}
    </Box>
  );
};

export default ContactSection;
